module.exports = __webpack_public_path__ + "images/fa-b2b-preview-image.jpg";